import styled, { css } from 'styled-components'

export const Wrapper = styled.div`
  padding: 24px;
`

export const Title = styled.div`
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 24px;
  background: #e30513;
  color: #fff;
  border-radius: 4px;
  animation-name: showText;
  animation-duration: 1s;

  @keyframes showText {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;

  ${({ mobile }) =>
    mobile &&
    css`
      @media screen and (max-width: 430px) {
        flex-direction: column-reverse;
      }
    `}
`

export const Col = styled.div`
  flex: 0 1 50%;
`

export const LegalCheckboxWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  font-size: 14px;
`
